import { translate } from "@/plugins/i18n";
import type BaseEnumType from "../../baseEnumType";
import Key from "@/app/types/common/key";
import { Maybe } from "@/components/utils/typeHelpers";


export class EnumRetailPaymentMethod implements BaseEnumType {
  private static allValues: EnumRetailPaymentMethod[] = []; // make sure this is top-most
  
  public static none = new EnumRetailPaymentMethod(0, "None", "enum_retail_payment_method_none");
  public static debitCreditCard = new EnumRetailPaymentMethod(1, "DebitCreditCard", "enum_retail_payment_method_debit_credit_card");
  public static other = new EnumRetailPaymentMethod(2, "Other", "enum_retail_payment_method_other");
  public static cash = new EnumRetailPaymentMethod(3, "Cash", "enum_retail_payment_method_cash");
  
  public key: number;
  public value: string;
  public translationKey: string;

  private constructor(key: number, value: string, translationKey: string) {
    this.key = key;
    this.value = value;
    this.translationKey = translationKey;
    EnumRetailPaymentMethod.allValues.push(this);
  }

  public get translation() { return translate(Key.fromString(this.translationKey)); }

  public isNone() { return this === EnumRetailPaymentMethod.none; }
  public isDebitCreditCard() { return this === EnumRetailPaymentMethod.debitCreditCard; }
  public isOther() { return this === EnumRetailPaymentMethod.other; }
  public isCash() { return this === EnumRetailPaymentMethod.cash; }

  public static getValues(): readonly EnumRetailPaymentMethod[] {
    return EnumRetailPaymentMethod.allValues;
  }

  public static getValuesExcept0(): readonly EnumRetailPaymentMethod[] {
    return EnumRetailPaymentMethod.allValues.filter((x) => x.key !== 0);
  }

  public static getByKey(key: number): EnumRetailPaymentMethod {
    const found = EnumRetailPaymentMethod.allValues.find(e => e.key === key);
    if (found === undefined) {
      throw new Error(`EnumRetailPaymentMethod - Key not found: ${ key }`);
    }

    return found;
  }

  public static getByValue(name: string, def?: EnumRetailPaymentMethod): EnumRetailPaymentMethod {
    const found = name ? EnumRetailPaymentMethod.allValues.find(e => e.value.toLowerCase() === name.toLowerCase()) : null;
    if (!found) {
      if (def) {
        return def;
      }
      throw new Error(`EnumRetailPaymentMethod - Value not found: ${ name }`);
    }

    return found;
  }

  public equals(other: Maybe<EnumRetailPaymentMethod>): boolean {
    return this.key === other?.key;
  }
}